import React from 'react';
import styles from './Thead.module.scss';

interface TheadProps {
  cols: string[];
}

export function Thead({ cols }: TheadProps) {
  return (
    <thead>
      <tr className={styles.row}>
        {cols.map((h, i) => (
          <th key={i} className={styles.cell}>
            {h}
          </th>
        ))}
      </tr>
    </thead>
  );
}
